<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .campaign-info {
    display: flex;
    align-items: center;
    gap: utils.in_rem(6px);
  }
</style>

<script>
  // Stores
  import { candidateStore } from "../stores";
  // Components
  import Link from "@sourcewhale/shared/svelte-design-system/components/atoms/Link.svelte";
  import StatusDot from "../../../elements/ProfileContactSideBarShared/StatusDot.svelte";

  $: campaignId = $candidateStore?.campaignId;
  $: campaignName = $candidateStore?.campaignName;
  $: candidateStatus = $candidateStore?.status;
</script>

<div class="campaign-info">
  <StatusDot
    {candidateStatus}
    tooltip={`Active on campaign '${campaignName}'`}
  />

  <span
    >Active on <Link
      href="/campaign?campaignId={campaignId}"
      target="_blank"
      rel="noopener noreferrer">'{campaignName}'</Link
    ></span
  >
</div>
